<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('view-action-documents')" class="fa fa-file-text-o fa-lg pointer" @click="seePdf" :title="uLang('app.show_type', { type: lang('app.action_document') })"></i>
        <i v-if="this.$can('update-action-documents')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.action_document') })"></i>
        <i v-if="this.$can('update-action-documents')" class="fa fa-archive fa-lg pointer" :class="{'fa-unarchive': this.data.is_archived}" @click="archive" :title="uLang('app.archive_type', { type: lang('app.action_document') })"></i>
        <i v-if="this.$can('delete-action-documents')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.action_document') })"></i>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { DestroyAlert, SuccessAlert, ErrorAlert, ConfirmationAlert } from '~/Swals'

    export default {
        name: 'actions',
        props: ['data', 'index'],

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            archive() {
                if (!this.data.is_archived) {
                    new ConfirmationAlert({ entity: this.lang('app.action_document'), text: "Het item (sjabloon) wordt in het archief geplaatst." }).show().then(() => {
                        window.axios.post(route('action-documents.archive', { action_document: this.data.id }))
                            .then(() => {
                                new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_updated', {
                                    entity: this.lang('app.action_document')
                                })}).show();
                                vue.$emit('reloadTable');
                            }).catch(({ response }) => {
                                new ErrorAlert({ text: response.data.message }).show();
                            });
                    })
                } else {
                    new ConfirmationAlert({ entity: this.lang('app.action_document'), text: "Het item (sjabloon) is niet gearchiveerd." }).show().then(() => {
                        window.axios.post(route('action-documents.unarchive', { action_document: this.data.id }))
                            .then(() => {
                                new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_updated', {
                                    entity: this.lang('app.action_document')
                                })}).show();
                                vue.$emit('reloadTable');
                            }).catch(({ response }) => {
                                new ErrorAlert({ text: response.data.message }).show();
                            });
                    })
                }
            },

            remove() {
                new DestroyAlert({ entity: this.lang('app.action_document') }).show().then(async () => {
                    this.destroy()
                });
            },

            edit() {
                this.$router.push({ name: 'admin.action-documents.edit', params: { id: this.data.id }})
            },

            async destroy() {
                await window.axios.delete(route('action-documents.destroy', { action_document: this.data.id }))
                    .then(() => {
                        new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', {
                            entity: this.lang('app.action_document')
                        })}).show();
                        vue.$emit('reloadTable');
                    }).catch(({ response }) => {
                        new ErrorAlert({ text: response.data.message }).show();
                    });
            },

            async seePdf() {
                window.location.href = route('action-documents.pdf.index', { action_document: this.data.id });
            },
        }
    }
</script>

<style lang="scss" scoped>

.fa-archive.fa-unarchive {
    color: #cccccc;
}
</style>